import { useAppSelector } from 'hooks/reduxHooks'
import getLuxLoyaltyDisplayTier from 'luxLoyalty/selectors/getLuxLoyaltyDisplayTier'
import getLuxLoyaltyNextTier from 'luxLoyalty/selectors/getLuxLoyaltyNextTier'
import getLuxLoyaltyTierDisplayName from 'luxLoyalty/selectors/getLuxLoyaltyTierDisplayName'

/**
 * Returns the current loyalty teir for the user
 * If not entered in the program, will return the 'base' default tier
 */
function useCurrentLoyaltyTier(): [tier: App.LuxLoyaltyTier, tierName: string, nextTier: App.LuxLoyaltyTier | undefined, nextTierName: string | undefined] {
  const tier = useAppSelector(state => getLuxLoyaltyDisplayTier(state))
  const nextTier = useAppSelector(state => getLuxLoyaltyNextTier(state))

  return [
    tier,
    getLuxLoyaltyTierDisplayName(tier),
    nextTier,
    nextTier ? getLuxLoyaltyTierDisplayName(nextTier) : undefined,
  ]
}

export default useCurrentLoyaltyTier
